import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import AppGenieImage from 'components/AppGenieImage';
import { MuiButtonWarning } from 'components/MuiExtras/Button/MuiButtons';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router';

////////////////////////////////////////////////////////////////////////////////////////

type Props = RouteComponentProps<{}> & WithTranslation;

////////////////////////////////////////////////////////////////////////////////////////

class ServerNotAvailable extends React.Component<Props> {

    public render() {
        const { t } = this.props;

        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: "100%" }}>
                <Grid item xs sm={10} md={8} lg={6}>
                    <Box mt={4}>
                        <Card>
                            <CardContent>
                                <Grid container justifyContent="center" alignItems="center" wrap="nowrap">
                                    <Grid item>
                                        <AppGenieImage />
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="h4">
                                            {t("Views.Public.ServerNotAvailable.HeaderTitle")}
                                        </Typography>
                                        <Typography variant="body1">
                                            <p>{t("Views.Public.ServerNotAvailable.Msg1")}</p>
                                        </Typography>
                                        <MuiButtonWarning onClick={() => window.location.replace("/")}>
                                            <span>Recarregar</span>
                                        </MuiButtonWarning>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>
                </Grid>
            </Grid>
        );
    }
}

export default withTranslation()(ServerNotAvailable);